import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card py-5" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = {
  class: "d-flex justify-content-center",
  style: {"height":"1024px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "spinner spinner-primary spinner-lg mr-15" }, null, -1)
const _hoisted_5 = { class: "fs-4 text-gray-700 mt-10" }

import {computed, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {Actions} from "@/store/enums/StoreEnums";
import { useRoute, useRouter } from "vue-router";
import type {CertificateVerifyType} from "@/types/CertificateType";
import moment from "moment/moment";
import { useI18n } from 'vue-i18n';
import CertificateViewComponent from "@/components/certificate/CertificateViewComponent.vue";
import CertificationViewComponent from "@/components/certification/CertificationViewComponent.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const { t } = useI18n();
const certificateResponse = computed(() => store.getters.getCertificateResponse);
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const validationIdParams = ref();
const certificate = ref<CertificateVerifyType>();
const appUrl = ref(window.location.origin);


if(route.params.id) {
  validationIdParams.value = route.params.id
}

onMounted(async () => {


  try {
    await store.dispatch(Actions.VERIFY_CERTIFICATE, validationIdParams.value);
    if (certificateResponse.value?.status !== 200) {
      await router.push({ name: 'certificate' });
    }else{
      certificate.value = certificateResponse.value.data

      setMetaTag('og:title', slugToName(certificate.value?.certificate_name || ''));
      setMetaTag('og:description', certificate.value?.certificate_description || '');
      setMetaTag('og:image', '/media/certificate/logo1.png');
      setMetaTag('og:url', appUrl.value);
    }
  } catch (e) {
    console.error('Error verifying certificate:', e);
  } finally {
  }

})

const handleClick = () =>{
  window.open(`${appUrl.value}/certificate/validate?id=${certificate.value?.validation_id}`)
}

const slugToName = (slug: string) =>{
  return slug.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

const setMetaTag = (property, content) => {
  let tag = document.querySelector(`meta[property='${property}']`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('property', property);
    document.getElementsByTagName('head')[0].appendChild(tag);
  }
  tag.setAttribute('content', content);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (certificate.value && !certificate.value.is_certification)
      ? (_openBlock(), _createBlock(CertificateViewComponent, {
          key: 0,
          certificate: certificate.value
        }, null, 8, ["certificate"]))
      : (certificate.value && certificate.value.is_certification)
        ? (_openBlock(), _createBlock(CertificationViewComponent, {
            key: 1,
            certification: certificate.value
          }, null, 8, ["certification"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.loading`)) + "...", 1)
            ])
          ]))
  ]))
}
}

})